<template>
  <Transition
    v-if="display || !loading"
    mode="out-in"
    enter-active-class="transition ease-in"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
    appear>
    <div v-if="loading" :class="{ 'flex justify-center': center }">
      <i class="fa-sharp fa-regular fa-spinner-third fa-fw fa-spin" :class="classes"></i>
      <span v-if="message" class="ml-2 text-sm">{{ message }}</span>
    </div>
    <div v-else class="empty:hidden">
      <slot />
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'secondary'
    },
    center: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    },
    debounce: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return this.color === 'white' ? 'text-white' : 'text-primary-500 dark:text-primary-600'
    }
  },
  data() {
    return {
      display: false,
      timeout: null
    }
  },
  mounted() {
    this.display = !this.debounce
  },
  beforeUnmount() {
    clearTimeout(this.timeout)
  },
  watch: {
    loading: {
      handler(val) {
        clearTimeout(this.timeout)
        if (!val) {
          return
        }

        if (this.debounce) {
          if (val) {
            this.display = false
          }
          this.timeout = setTimeout(() => (this.display = true), 1000)
        }
      },
      immediate: true
    }
  }
}
</script>
